/* PetVault Dashboard logic (v2, local-first) - Pure Majesty Pets */
const API_URL = window.PETVAULT_API_URL || '';

const BREED_DB = {
  dog: [
    'Labrador Retriever','German Shepherd','Golden Retriever','French Bulldog','Bulldog','Poodle','Beagle',
    'Rottweiler','German Shorthaired Pointer','Dachshund','Pembroke Welsh Corgi','Australian Shepherd',
    'Yorkshire Terrier','Cavalier King Charles Spaniel','Doberman Pinscher','Boxer','Miniature Schnauzer',
    'Cane Corso','Great Dane','Shih Tzu','Siberian Husky','Bernese Mountain Dog','Pomeranian',
    'Boston Terrier','Havanese','Shetland Sheepdog','Brittany','English Springer Spaniel','Cocker Spaniel',
    'Miniature American Shepherd','Border Collie','Vizsla','Weimaraner','Belgian Malinois','Collie',
    'Basset Hound','Newfoundland','Rhodesian Ridgeback','West Highland White Terrier','Bichon Frise',
    'Shiba Inu','Akita','Bloodhound','Portuguese Water Dog','St. Bernard','Scottish Terrier',
    'Soft Coated Wheaten Terrier','Dalmatian','Samoyed','Chihuahua','Bull Terrier','Pit Bull Terrier',
    'Maltese','Whippet','Chinese Shar-Pei','Airedale Terrier','Alaskan Malamute','Irish Setter',
    'Old English Sheepdog','Italian Greyhound','Jack Russell Terrier','Papillon','Chow Chow',
    'Australian Cattle Dog','Lhasa Apso','Great Pyrenees','Pug','Irish Wolfhound','Basenji',
    'Staffordshire Bull Terrier','Bouvier des Flandres','Tibetan Mastiff','Cairn Terrier'
  ],
  cat: [
    'Persian','Maine Coon','Ragdoll','British Shorthair','Exotic Shorthair','Abyssinian','Scottish Fold',
    'Sphynx','Siamese','Devon Rex','Birman','Oriental Shorthair','Cornish Rex','Burmese','Norwegian Forest Cat',
    'Tonkinese','Russian Blue','Bengal','Savannah','Siberian','Ragamuffin','Turkish Angora','Manx',
    'Japanese Bobtail','Somali','Ocicat','Chartreux','Balinese','Bombay','Egyptian Mau','Himalayan',
    'American Shorthair','American Curl','Selkirk Rex','British Longhair','Singapura','Korat',
    'Havana Brown','Snowshoe','Toyger','LaPerm','Turkish Van','Nebelung','Peterbald','Munchkin',
    'Domestic Shorthair','Domestic Longhair','Tabby (mixed)'
  ],
  bird: [],
  other: []
};

let currentPetId = null;
let petsData = [];
let allergiesList = [];
let pathologiesList = [];

document.addEventListener('DOMContentLoaded', function() {
  loadPets();
  setupEventListeners();
  loadPawCoins();
  updateUserUI();
  loadFromServer();
});

function loadPawCoins() {
  var saved = JSON.parse(localStorage.getItem('petvault_rewards')) || {};
  var points = saved.points || 0;
  var tier = 'Bronze';
  if (points >= 5000) tier = 'Platinum';
  else if (points >= 2000) tier = 'Gold Premium';
  else if (points >= 500) tier = 'Silver';

  var pointsEl = document.getElementById('pawcoinsPoints');
  var tierEl = document.getElementById('pawcoinsTier');
  if (pointsEl) pointsEl.textContent = points.toLocaleString();
  if (tierEl) tierEl.textContent = tier;
}

function setupEventListeners() {
  document.querySelectorAll('input[name="species"]').forEach(function(radio) {
    radio.addEventListener('change', function() {
      document.getElementById('petBreed').value = '';
      document.getElementById('breedAiHint').style.display = 'none';
    });
  });

  var breedInput = document.getElementById('petBreed');
  var suggestionsBox = document.getElementById('breedSuggestions');

  breedInput.addEventListener('input', function() {
    var query = this.value.trim().toLowerCase();
    var species = document.querySelector('input[name="species"]:checked').value;
    var breeds = BREED_DB[species] || [];

    if (query.length < 1) {
      suggestionsBox.style.display = 'none';
      return;
    }

    var matches = breeds.filter(function(b) {
      return b.toLowerCase().indexOf(query) !== -1;
    }).slice(0, 8);

    if (matches.length === 0 && query.length >= 2) {
      suggestionsBox.innerHTML = '<div style="padding:10px 14px;color:#c9a84c;font-size:13px;cursor:pointer;" onclick="acceptCustomBreed()">Use "' + breedInput.value + '" as breed</div>';
      suggestionsBox.style.display = 'block';
      fetchBreedInfoFromAI(breedInput.value, species);
    } else if (matches.length > 0) {
      suggestionsBox.innerHTML = matches.map(function(b) {
        return '<div style="padding:10px 14px;cursor:pointer;font-size:14px;border-bottom:1px solid #f0f0f0;transition:background 0.15s;" onmouseover="this.style.background=\'#f9f7f3\'" onmouseout="this.style.background=\'white\'" onclick="selectBreed(\'' + b.replace(/'/g, "\\'") + '\')">' + b + '</div>';
      }).join('');
      suggestionsBox.style.display = 'block';
    } else {
      suggestionsBox.style.display = 'none';
    }
  });

  breedInput.addEventListener('blur', function() {
    setTimeout(function() { suggestionsBox.style.display = 'none'; }, 200);
  });

  document.getElementById('petForm').addEventListener('submit', savePet);
  document.getElementById('recordForm').addEventListener('submit', saveRecord);
  document.getElementById('vaccineForm').addEventListener('submit', saveVaccine);
  document.getElementById('reminderForm').addEventListener('submit', saveReminder);
  document.getElementById('supplementForm').addEventListener('submit', saveSupplement);
}

function selectBreed(breed) {
  document.getElementById('petBreed').value = breed;
  document.getElementById('breedSuggestions').style.display = 'none';
  fetchBreedInfoFromAI(breed, document.querySelector('input[name="species"]:checked').value);
}

function acceptCustomBreed() {
  document.getElementById('breedSuggestions').style.display = 'none';
}

var PV_BREED_TIPS = {
  'labrador retriever': 'Labs are prone to hip dysplasia and weight gain - keep them lean and support joints early.',
  'german shepherd': 'Watch hips and elbows - joint support and lean weight matter most for Shepherds.',
  'golden retriever': 'Goldens often develop skin allergies and hip issues - regular grooming and joint care help.',
  'french bulldog': 'Frenchies overheat easily and have sensitive skin - avoid heat and watch for skin folds irritation.',
  'bulldog': 'Bulldogs need skin-fold cleaning and weight control - breathing worsens with extra pounds.',
  'poodle': 'Poodles are prone to ear infections - keep ears clean and dry after grooming or swimming.',
  'beagle': 'Beagles gain weight easily and are prone to ear infections - measure meals and check ears weekly.',
  'dachshund': 'Watch the back - keep Dachshunds lean and discourage jumping to protect their long spine.',
  'yorkshire terrier': 'Yorkies are prone to dental disease - daily dental care makes a big difference.',
  'shih tzu': 'Shih Tzus need daily eye care and tear-stain cleaning - keep facial hair trimmed.',
  'pomeranian': 'Poms are prone to dental disease and luxating patella - dental care plus joint support help.',
  'boxer': 'Boxers are sensitive to heat and prone to heart conditions - regular vet checks recommended.',
  'great dane': 'Giant breeds risk bloat - feed smaller meals and avoid exercise right after eating.',
  'siberian husky': 'Huskies need lots of exercise - watch eyes (cataracts) as they age.',
  'chihuahua': 'Chihuahuas are prone to dental crowding issues - brush or use dental powder daily.',
  'pug': 'Pugs overheat fast and have delicate eyes - keep them cool and wipe facial folds.',
  'border collie': 'High-energy worker - joint wear is common, mental stimulation is a must.',
  'australian shepherd': 'Aussies are active dogs prone to hip issues - balance high activity with joint support.',
  'cocker spaniel': 'Those lovely ears trap moisture - clean weekly to prevent infections.',
  'basset hound': 'Long ears and heavy build - weekly ear cleaning and weight control are key.',
  'persian': 'Persians need daily eye cleaning and regular grooming to prevent mats and tear stains.',
  'maine coon': 'Large cats with joint stress - watch weight and support hips as they age.',
  'siamese': 'Siamese are prone to dental disease - start a dental routine early.',
  'ragdoll': 'Watch weight - Ragdolls are laid-back and can gain quickly; keep joints supported.',
  'sphynx': 'No coat means oily skin - regular gentle baths and warmth in winter.'
};

function fetchBreedInfoFromAI(breed, species) {
  var hintEl = document.getElementById('breedAiHint');
  var tip = PV_BREED_TIPS[(breed || '').toLowerCase()];
  if (!tip) {
    tip = species === 'cat'
      ? 'Tip: keep vaccines current and book a vet checkup at least once a year.'
      : 'Tip: lean weight, dental care and yearly checkups prevent the most common issues.';
  }
  hintEl.style.display = 'block';
  hintEl.textContent = tip;
}

async function loadPets() {
  petsData = JSON.parse(localStorage.getItem('petvault_pets')) || [];
  renderPets();
  renderUpcomingReminders();
}

function renderPets() {
  const container = document.getElementById('petsGridContainer');
  const emptyState = document.getElementById('emptyState');

  if (petsData.length === 0) {
    container.style.display = 'none';
    emptyState.style.display = 'block';
    return;
  }

  container.style.display = 'grid';
  emptyState.style.display = 'none';
  container.innerHTML = '';

  petsData.forEach(pet => {
    const card = createPetCard(pet);
    container.appendChild(card);
  });
}

function createPetCard(pet) {
  const card = document.createElement('div');
  card.className = 'pet-card';

  const nextReminder = getNextReminder(pet.id);
  const reminderText = nextReminder ? 'Next visit: ' + nextReminder : 'No reminders';

  const healthStatus = getHealthStatus(pet);
  const healthColor = healthStatus === 'good' ? 'good' : healthStatus === 'attention' ? 'attention' : 'urgent';

  card.innerHTML = `
    <div class="pet-card-header">
      <div class="pet-avatar ${pet.species || 'dog'}">${pet.name.charAt(0).toUpperCase()}</div>
      <div class="pet-card-info">
        <div class="pet-name">${pet.name}</div>
        <div class="pet-species">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" opacity="0.6">
            <circle cx="12" cy="12" r="10"></circle>
          </svg>
          ${pet.breed || 'Unknown Breed'}
        </div>
        <div class="pet-details">${calculateAge(pet.birthDate)} years old • ${pet.weight} kg</div>
        <div class="health-indicator">
          <div class="health-dot ${healthColor}"></div>
          ${healthStatus === 'good' ? 'Healthy' : healthStatus === 'attention' ? 'Attention needed' : 'Urgent'}
        </div>
      </div>
    </div>
    <div class="pet-next-reminder">${reminderText}</div>
    <div class="pet-card-actions">
      <button class="view-file-btn" onclick="viewPetDetail('${pet.id}')">View Record</button>
      <button class="edit-btn" onclick="editPet('${pet.id}')" title="Edit">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
        </svg>
      </button>
      <button class="delete-btn" onclick="deletePet('${pet.id}')" title="Delete">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"></polyline>
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          <line x1="10" y1="11" x2="10" y2="17"></line>
          <line x1="14" y1="11" x2="14" y2="17"></line>
        </svg>
      </button>
    </div>
  `;

  return card;
}

function calculateAge(birthDate) {
  if (!birthDate) return '?';
  const birth = new Date(birthDate);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) age--;
  return age;
}

function getHealthStatus(pet) {
  return 'good';
}

function getNextReminder(petId) {
  const reminders = JSON.parse(localStorage.getItem('petvault_reminders')) || [];
  const petReminders = reminders.filter(r => r.petId === petId).sort((a, b) => new Date(a.date) - new Date(b.date));
  if (petReminders.length > 0) {
    return new Date(petReminders[0].date).toLocaleDateString('en-US');
  }
  return null;
}

function openAddPetModal() {
  currentPetId = null;
  document.getElementById('petForm').reset();
  document.getElementById('petModalTitle').textContent = 'Add a Pet';
  allergiesList = [];
  pathologiesList = [];
  updateTagDisplay('allergies');
  updateTagDisplay('pathologies');
  document.getElementById('petModal').classList.add('active');
}

function editPet(petId) {
  const pet = petsData.find(p => p.id === petId);
  if (!pet) return;

  currentPetId = petId;
  document.getElementById('petName').value = pet.name;
  document.querySelector('input[name="species"][value="' + pet.species + '"]').checked = true;
  document.querySelector('input[name="sex"][value="' + pet.sex + '"]').checked = true;
  setTimeout(() => {
    document.getElementById('petBreed').value = pet.breed;
  }, 100);
  document.getElementById('petBirthDate').value = pet.birthDate;
  document.getElementById('petWeight').value = pet.weight;
  allergiesList = pet.allergies || [];
  pathologiesList = pet.pathologies || [];
  updateTagDisplay('allergies');
  updateTagDisplay('pathologies');
  document.getElementById('petModalTitle').textContent = 'Edit Pet';
  document.getElementById('petModal').classList.add('active');
}

function closePetModal() {
  document.getElementById('petModal').classList.remove('active');
  currentPetId = null;
}

async function savePet(event) {
  event.preventDefault();

  const pet = {
    id: currentPetId || Date.now().toString(),
    name: document.getElementById('petName').value,
    species: document.querySelector('input[name="species"]:checked').value,
    breed: document.getElementById('petBreed').value,
    birthDate: document.getElementById('petBirthDate').value,
    weight: parseFloat(document.getElementById('petWeight').value),
    sex: document.querySelector('input[name="sex"]:checked').value,
    allergies: allergiesList,
    pathologies: pathologiesList
  };

  if (currentPetId) {
    const index = petsData.findIndex(p => p.id === currentPetId);
    if (index !== -1) petsData[index] = pet;
  } else {
    petsData.push(pet);
  }

  localStorage.setItem('petvault_pets', JSON.stringify(petsData));
  closePetModal();
  loadPets();
}

function deletePet(petId) {
  if (confirm('Are you sure you want to delete this pet?')) {
    petsData = petsData.filter(p => p.id !== petId);
    localStorage.setItem('petvault_pets', JSON.stringify(petsData));
    renderPets();
  }
}

function handleTagInput(event, type) {
  if (event.key === 'Enter') {
    event.preventDefault();
    const input = event.target;
    const value = input.value.trim();
    if (value) {
      if (type === 'allergies') {
        allergiesList.push(value);
      } else if (type === 'pathologies') {
        pathologiesList.push(value);
      }
      input.value = '';
      updateTagDisplay(type);
    }
  }
}

function updateTagDisplay(type) {
  const container = document.getElementById(type === 'allergies' ? 'allergiesInput' : 'pathologiesInput');
  const input = document.getElementById(type === 'allergies' ? 'allergiesField' : 'pathologiesField');
  const list = type === 'allergies' ? allergiesList : pathologiesList;

  const tags = container.querySelectorAll('.tag');
  tags.forEach(tag => tag.remove());

  list.forEach((tag, index) => {
    const tagEl = document.createElement('div');
    tagEl.className = 'tag';
    tagEl.innerHTML = tag + ' <button type="button" onclick="removeTag(' + index + ', \'' + type + '\')">&times;</button>';
    container.insertBefore(tagEl, input);
  });
}

function removeTag(index, type) {
  if (type === 'allergies') {
    allergiesList.splice(index, 1);
  } else {
    pathologiesList.splice(index, 1);
  }
  updateTagDisplay(type);
}

function handleDragOver(event) {
  event.preventDefault();
  document.getElementById('uploadZone').classList.add('dragover');
}

function handleDragLeave(event) {
  document.getElementById('uploadZone').classList.remove('dragover');
}

function handleDrop(event) {
  event.preventDefault();
  document.getElementById('uploadZone').classList.remove('dragover');
  const files = event.dataTransfer.files;
  if (files.length > 0) {
    document.getElementById('petPhoto').files = files;
  }
}

function viewPetDetail(petId) {
  currentPetId = petId;
  const pet = petsData.find(p => p.id === petId);
  if (!pet) return;

  document.getElementById('petsGridContainer').style.display = 'none';
  document.getElementById('emptyState').style.display = 'none';
  document.getElementById('petDetailView').classList.add('active');

  const avatar = document.getElementById('detailPetAvatar');
  avatar.textContent = pet.name.charAt(0).toUpperCase();
  avatar.className = 'pet-avatar ' + (pet.species || 'dog');

  document.getElementById('detailPetName').textContent = pet.name;
  document.getElementById('detailPetSpecies').textContent = pet.species.charAt(0).toUpperCase() + pet.species.slice(1);
  document.getElementById('detailPetBreed').textContent = pet.breed;
  document.getElementById('detailPetAge').textContent = calculateAge(pet.birthDate) + ' years old';
  document.getElementById('detailPetWeight').textContent = pet.weight + ' kg';
  document.getElementById('detailPetSex').textContent = pet.sex === 'male' ? 'Male' : pet.sex === 'female' ? 'Female' : 'Neutered/Spayed';

  loadPetDetails(petId);
  switchTab(null, 'overview');
}

function closePetDetail() {
  document.getElementById('petDetailView').classList.remove('active');
  document.getElementById('petsGridContainer').style.display = 'grid';
  currentPetId = null;
}

function switchTab(event, tabName) {
  if (event) event.preventDefault();

  document.querySelectorAll('#petvault-dashboard .tab-button').forEach(btn => btn.classList.remove('active'));
  document.querySelectorAll('#petvault-dashboard .tab-content').forEach(tab => tab.classList.remove('active'));

  if (event && event.target) {
    event.target.classList.add('active');
  } else {
    const btn = document.querySelector('#petvault-dashboard .tab-button[onclick*="' + tabName + '"]');
    if (btn) btn.classList.add('active');
  }
  document.getElementById(tabName).classList.add('active');
}

function loadPetDetails(petId) {
  const records = JSON.parse(localStorage.getItem('petvault_records')) || [];
  const vaccines = JSON.parse(localStorage.getItem('petvault_vaccines')) || [];
  const reminders = JSON.parse(localStorage.getItem('petvault_reminders')) || [];
  const supplements = JSON.parse(localStorage.getItem('petvault_supplements')) || [];

  const petRecords = records.filter(r => r.petId === petId);
  const petVaccines = vaccines.filter(v => v.petId === petId);
  const petReminders = reminders.filter(r => r.petId === petId);
  const petSupplements = supplements.filter(s => s.petId === petId);

  const pet = petsData.find(p => p.id === petId);
  updateSummaryCards(pet, petRecords, petVaccines);

  renderOverview(petRecords);
  renderMedicalHistory(petRecords);
  renderVaccines(petVaccines);
  renderReminders(petReminders);
  renderSupplements(petSupplements);
}

function updateSummaryCards(pet, records, vaccines) {
  var weightEl = document.getElementById('overviewWeight');
  var vaccineEl = document.getElementById('nextVaccine');
  var checkupEl = document.getElementById('lastCheckup');

  if (weightEl) {
    weightEl.textContent = pet && pet.weight ? pet.weight + ' kg' : '--';
  }

  if (vaccineEl) {
    var now = new Date();
    var upcoming = vaccines
      .filter(function(v) { return v.nextDate && new Date(v.nextDate) > now; })
      .sort(function(a, b) { return new Date(a.nextDate) - new Date(b.nextDate); });
    if (upcoming.length > 0) {
      var d = new Date(upcoming[0].nextDate);
      vaccineEl.textContent = d.toLocaleDateString('en-US', { day: 'numeric', month: 'long' });
    } else {
      vaccineEl.textContent = 'None scheduled';
    }
  }

  if (checkupEl) {
    var checkups = records
      .filter(function(r) { return r.type && r.type.toLowerCase().indexOf('checkup') !== -1 || r.type && r.type.toLowerCase().indexOf('consultation') !== -1 || r.type && r.type.toLowerCase().indexOf('exam') !== -1; })
      .sort(function(a, b) { return new Date(b.date) - new Date(a.date); });
    if (checkups.length > 0) {
      var d2 = new Date(checkups[0].date);
      checkupEl.textContent = d2.toLocaleDateString('en-US', { day: 'numeric', month: 'long' });
    } else if (records.length > 0) {
      var sorted = records.sort(function(a, b) { return new Date(b.date) - new Date(a.date); });
      var d3 = new Date(sorted[0].date);
      checkupEl.textContent = d3.toLocaleDateString('en-US', { day: 'numeric', month: 'long' });
    } else {
      checkupEl.textContent = 'No records';
    }
  }
}

function renderOverview(records) {
  const timeline = document.getElementById('overviewRecords');
  const sorted = records.sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, 3);

  if (sorted.length === 0) {
    timeline.innerHTML = '<p style="color: #888; text-align: center;">No records</p>';
    return;
  }

  timeline.innerHTML = sorted.map(record => `
    <div class="timeline-item">
      <div class="timeline-date">${new Date(record.date).toLocaleDateString('en-US')}</div>
      <div class="timeline-title">${record.type}</div>
      <div class="timeline-description">${record.description}</div>
    </div>
  `).join('');
}

function renderMedicalHistory(records) {
  const timeline = document.getElementById('medicalTimeline');
  const sorted = records.sort((a, b) => new Date(b.date) - new Date(a.date));

  if (sorted.length === 0) {
    timeline.innerHTML = '<p style="color: #888; text-align: center;">No records medical</p>';
    return;
  }

  timeline.innerHTML = sorted.map(record => `
    <div class="timeline-item">
      <div class="timeline-date">${new Date(record.date).toLocaleDateString('en-US')}</div>
      <div class="timeline-title">${record.type}</div>
      <div class="timeline-description">${record.description}${record.vetName ? ' - ' + record.vetName : ''}</div>
    </div>
  `).join('');
}

function renderVaccines(vaccines) {
  const table = document.getElementById('vaccinesTable');

  if (vaccines.length === 0) {
    table.innerHTML = '<tr><td colspan="4" style="text-align: center; padding: 20px; color: #888;">No vaccines</td></tr>';
    return;
  }

  table.innerHTML = vaccines.map(vaccine => {
    const nextDate = new Date(vaccine.nextDate);
    const today = new Date();
    let status = 'ok';
    if (nextDate < today) status = 'late';
    else if ((nextDate - today) / (1000 * 60 * 60 * 24) < 30) status = 'attention';

    const statusText = status === 'ok' ? 'Up to date' : status === 'attention' ? 'Due soon' : 'Overdue';

    return `
      <tr>
        <td>${vaccine.name}</td>
        <td>${new Date(vaccine.date).toLocaleDateString('en-US')}</td>
        <td>${new Date(vaccine.nextDate).toLocaleDateString('en-US')}</td>
        <td><span class="status-badge ${status}">${statusText}</span></td>
      </tr>
    `;
  }).join('');
}

function renderReminders(reminders) {
  const list = document.getElementById('remindersList');
  const sorted = reminders.sort((a, b) => new Date(a.date) - new Date(b.date));

  if (sorted.length === 0) {
    list.innerHTML = '<p style="color: #888; text-align: center;">No reminders</p>';
    return;
  }

  list.innerHTML = sorted.map(reminder => `
    <div class="reminder-item">
      <div class="reminder-date">${new Date(reminder.date).toLocaleDateString('en-US')} ${reminder.time || ''}</div>
      <div class="reminder-title">${reminder.title}</div>
      <div class="reminder-meta">${reminder.recurrence && reminder.recurrence !== 'none' ? 'Recurrence: ' + reminder.recurrence : ''}</div>
    </div>
  `).join('');
}

function renderUpcomingReminders() {
  const reminders = JSON.parse(localStorage.getItem('petvault_reminders')) || [];
  const upcoming = reminders.sort((a, b) => new Date(a.date) - new Date(b.date)).slice(0, 5);

  const container = document.getElementById('upcomingReminders');

  if (upcoming.length === 0) {
    container.innerHTML = '<div class="empty-reminders">No upcoming reminders</div>';
    return;
  }

  container.innerHTML = upcoming.map(reminder => {
    const pet = petsData.find(p => p.id === reminder.petId);
    const daysUntil = Math.ceil((new Date(reminder.date) - new Date()) / (1000 * 60 * 60 * 24));
    let urgency = 'urgency-normal';
    if (daysUntil < 0) urgency = 'urgency-urgent';
    else if (daysUntil < 7) urgency = 'urgency-warning';

    return `
      <div class="upcoming-item">
        <svg class="upcoming-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <circle cx="12" cy="12" r="1"></circle>
          <path d="M12 6v6"></path>
          <circle cx="12" cy="12" r="9"></circle>
        </svg>
        <div class="upcoming-content">
          <div class="upcoming-date">${new Date(reminder.date).toLocaleDateString('en-US')}</div>
          <div class="upcoming-title">${reminder.title}</div>
          <div class="upcoming-pet">${pet ? pet.name : 'Unknown Pet'}</div>
        </div>
        <div class="upcoming-urgency ${urgency}"></div>
      </div>
    `;
  }).join('');
}

function handleViewAllReminders(event) {
  event.preventDefault();
  switchTab(null, 'reminders');
}

function openAddRecordModal() {
  document.getElementById('recordForm').reset();
  document.getElementById('recordModal').classList.add('active');
}

function closeRecordModal() {
  document.getElementById('recordModal').classList.remove('active');
}

async function saveRecord(event) {
  event.preventDefault();

  const record = {
    id: Date.now().toString(),
    petId: currentPetId,
    type: document.getElementById('recordType').value,
    date: document.getElementById('recordDate').value,
    description: document.getElementById('recordDescription').value,
    vetName: document.getElementById('recordVetName').value
  };

  let records = JSON.parse(localStorage.getItem('petvault_records')) || [];
  records.push(record);
  localStorage.setItem('petvault_records', JSON.stringify(records));

  closeRecordModal();
  loadPetDetails(currentPetId);
}

function openAddVaccineModal() {
  document.getElementById('vaccineForm').reset();
  document.getElementById('vaccineModal').classList.add('active');
}

function closeVaccineModal() {
  document.getElementById('vaccineModal').classList.remove('active');
}

async function saveVaccine(event) {
  event.preventDefault();

  const vaccine = {
    id: Date.now().toString(),
    petId: currentPetId,
    name: document.getElementById('vaccineName').value,
    date: document.getElementById('vaccineDate').value,
    nextDate: document.getElementById('vaccineNextDate').value
  };

  let vaccines = JSON.parse(localStorage.getItem('petvault_vaccines')) || [];
  vaccines.push(vaccine);
  localStorage.setItem('petvault_vaccines', JSON.stringify(vaccines));

  closeVaccineModal();
  loadPetDetails(currentPetId);
}

function openAddReminderModal() {
  document.getElementById('reminderForm').reset();
  document.getElementById('reminderModal').classList.add('active');
}

function closeReminderModal() {
  document.getElementById('reminderModal').classList.remove('active');
}

async function saveReminder(event) {
  event.preventDefault();

  const reminder = {
    id: Date.now().toString(),
    petId: currentPetId,
    title: document.getElementById('reminderTitle').value,
    date: document.getElementById('reminderDate').value,
    time: document.getElementById('reminderTime').value,
    recurrence: document.getElementById('reminderRecurrence').value
  };

  let reminders = JSON.parse(localStorage.getItem('petvault_reminders')) || [];
  reminders.push(reminder);
  localStorage.setItem('petvault_reminders', JSON.stringify(reminders));

  closeReminderModal();
  loadPetDetails(currentPetId);
  renderUpcomingReminders();
}

function pvPetBundle() {
  var pet = petsData.find(function(p) { return p.id === currentPetId; });
  if (!pet) return null;
  var byPet = function(key) {
    return (JSON.parse(localStorage.getItem(key)) || []).filter(function(x) { return x.petId === currentPetId; });
  };
  return {
    pet: pet,
    records: byPet('petvault_records'),
    vaccines: byPet('petvault_vaccines'),
    reminders: byPet('petvault_reminders'),
    supplements: byPet('petvault_supplements')
  };
}

function pvSummaryText() {
  var b = pvPetBundle();
  if (!b) return '';
  var p = b.pet;
  var lines = [];
  lines.push('PET HEALTH SUMMARY - ' + p.name);
  lines.push('Generated by PetVault (Pure Majesty Pets) on ' + new Date().toLocaleDateString());
  lines.push('');
  lines.push('Species: ' + (p.species || '-') + '  |  Breed: ' + (p.breed || '-'));
  lines.push('Born: ' + (p.birthDate || '-') + '  |  Weight: ' + (p.weight || '-') + ' kg  |  Sex: ' + (p.sex || '-'));
  if (p.allergies && p.allergies.length) lines.push('Allergies: ' + p.allergies.join(', '));
  if (p.pathologies && p.pathologies.length) lines.push('Known conditions: ' + p.pathologies.join(', '));
  lines.push('');
  lines.push('VACCINES:');
  if (b.vaccines.length) {
    b.vaccines.forEach(function(v) { lines.push('  - ' + v.name + ' | given ' + v.date + ' | next due ' + (v.nextDate || '-')); });
  } else { lines.push('  (none recorded)'); }
  lines.push('');
  lines.push('MEDICAL HISTORY:');
  if (b.records.length) {
    b.records.forEach(function(r) { lines.push('  - ' + r.date + ' | ' + (r.type || 'visit') + ' | ' + (r.description || '') + (r.vetName ? ' (Dr. ' + r.vetName + ')' : '')); });
  } else { lines.push('  (none recorded)'); }
  lines.push('');
  lines.push('CURRENT SUPPLEMENTS:');
  var active = b.supplements.filter(function(s) { return s.active; });
  if (active.length) {
    active.forEach(function(s) { lines.push('  - ' + s.name + (s.dosage ? ' | ' + s.dosage : '') + ' | since ' + s.startDate); });
  } else { lines.push('  (none active)'); }
  return lines.join('\n');
}

function shareWithVet() {
  if (!currentPetId) { alert('Open a pet profile first.'); return; }
  var b = pvPetBundle();
  var subject = encodeURIComponent('Health summary - ' + b.pet.name);
  var body = encodeURIComponent(pvSummaryText() + '\n\n--\nSent from My PetVault, the free pet health record by Pure Majesty Pets\nhttps://www.puremajestypet.com/pages/my-petvault');
  window.location.href = 'mailto:?subject=' + subject + '&body=' + body;
}

function exportPDF() {
  if (!currentPetId) { alert('Open a pet profile first.'); return; }
  var b = pvPetBundle();
  var esc = function(t) { var d = document.createElement('div'); d.textContent = (t == null ? '' : String(t)); return d.innerHTML; };
  var rows = function(arr, fn, empty) { return arr.length ? arr.map(fn).join('') : '<tr><td colspan="4" style="color:#999;">' + empty + '</td></tr>'; };
  var w = window.open('', '_blank');
  if (!w) { alert('Please allow pop-ups to print the summary.'); return; }
  var doc = '<!DOCTYPE html><html><head><title>' + esc(b.pet.name) + ' - Health Summary</title>' +
    '<style>body{font-family:Georgia,serif;color:#1a1a2e;max-width:720px;margin:32px auto;padding:0 20px;}h1{border-bottom:3px solid #c9a84c;padding-bottom:8px;}h2{margin-top:28px;font-size:18px;color:#1a1a2e;}table{width:100%;border-collapse:collapse;font-size:13.5px;}td,th{border:1px solid #ddd;padding:7px 10px;text-align:left;}th{background:#f6f2e8;}p.meta{color:#666;font-size:13px;}footer{margin-top:36px;font-size:11.5px;color:#999;border-top:1px solid #eee;padding-top:10px;}</style></head><body>' +
    '<h1>' + esc(b.pet.name) + ' &mdash; Pet Health Summary</h1>' +
    '<p class="meta">Generated ' + new Date().toLocaleDateString() + ' &middot; My PetVault by Pure Majesty Pets</p>' +
    '<h2>Profile</h2><table>' +
    '<tr><th>Species</th><td>' + esc(b.pet.species) + '</td><th>Breed</th><td>' + esc(b.pet.breed) + '</td></tr>' +
    '<tr><th>Born</th><td>' + esc(b.pet.birthDate) + '</td><th>Weight</th><td>' + esc(b.pet.weight) + ' kg</td></tr>' +
    '<tr><th>Sex</th><td>' + esc(b.pet.sex) + '</td><th>Allergies</th><td>' + esc((b.pet.allergies || []).join(', ') || 'None recorded') + '</td></tr>' +
    '<tr><th>Conditions</th><td colspan="3">' + esc((b.pet.pathologies || []).join(', ') || 'None recorded') + '</td></tr></table>' +
    '<h2>Vaccines</h2><table><tr><th>Vaccine</th><th>Date given</th><th>Next due</th></tr>' +
    rows(b.vaccines, function(v) { return '<tr><td>' + esc(v.name) + '</td><td>' + esc(v.date) + '</td><td>' + esc(v.nextDate) + '</td></tr>'; }, 'No vaccines recorded') + '</table>' +
    '<h2>Medical history</h2><table><tr><th>Date</th><th>Type</th><th>Details</th><th>Vet</th></tr>' +
    rows(b.records, function(r) { return '<tr><td>' + esc(r.date) + '</td><td>' + esc(r.type) + '</td><td>' + esc(r.description) + '</td><td>' + esc(r.vetName) + '</td></tr>'; }, 'No records') + '</table>' +
    '<h2>Active supplements</h2><table><tr><th>Supplement</th><th>Dosage</th><th>Since</th></tr>' +
    rows(b.supplements.filter(function(s) { return s.active; }), function(s) { return '<tr><td>' + esc(s.name) + '</td><td>' + esc(s.dosage) + '</td><td>' + esc(s.startDate) + '</td></tr>'; }, 'No active supplements') + '</table>' +
    '<footer>This summary was generated from owner-entered records in My PetVault (puremajestypet.com). It is not a veterinary document.</footer>' +
    '<scr' + 'ipt>window.onload=function(){window.print();};</scr' + 'ipt></body></html>';
  w.document.write(doc);
  w.document.close();
}

/* ===== SUPPLEMENTS ===== */

function openAddSupplementModal() {
  document.getElementById('supplementForm').reset();
  document.getElementById('supplementModal').classList.add('active');
}

function closeSupplementModal() {
  document.getElementById('supplementModal').classList.remove('active');
}

function saveSupplement(event) {
  event.preventDefault();

  var supplement = {
    id: Date.now().toString(),
    petId: currentPetId,
    name: document.getElementById('supplementName').value,
    dosage: document.getElementById('supplementDosage').value,
    startDate: document.getElementById('supplementStartDate').value,
    purpose: document.getElementById('supplementPurpose').value,
    notes: document.getElementById('supplementNotes').value,
    active: true
  };

  var supplements = JSON.parse(localStorage.getItem('petvault_supplements')) || [];
  supplements.push(supplement);
  localStorage.setItem('petvault_supplements', JSON.stringify(supplements));

  closeSupplementModal();
  loadPetDetails(currentPetId);

  var rewardsData = JSON.parse(localStorage.getItem('petvault_rewards')) || { points: 0, history: [] };
  rewardsData.points = (rewardsData.points || 0) + 10;
  if (!rewardsData.history) rewardsData.history = [];
  rewardsData.history.push({ date: new Date().toISOString(), action: 'Added supplement: ' + supplement.name, points: 10 });
  localStorage.setItem('petvault_rewards', JSON.stringify(rewardsData));
  loadPawCoins();
}

var PV_SHOP_MAP = {
  joints: { name: 'Hip & Joint Chews', url: '/products/dog-hip-and-joint-chews' },
  skin: { name: 'Allergy & Itch Relief Chews', url: '/products/dog-itchy-skin-supplement' },
  anxiety: { name: 'Melatonin Calming Drops', url: '/products/melatonin-for-dogs' },
  dental: { name: 'Dog Dental Powder', url: '/products/dog-dental-powder' },
  ears: { name: 'Vet-Strength Ear Cleaner', url: '/products/dog-ear-cleaner' },
  eyes: { name: 'Eye Cleaning Rinse', url: '/products/dog-eye-cleaning-rinse' },
  digestion: { name: 'Liquid Probiotic', url: '/products/liquid-probiotic-for-dogs' },
  immunity: { name: 'Immune Support Drops', url: '/products/dog-immune-support-drops' },
  senior: { name: 'Senior Mobility Chews', url: '/products/senior-dog-mobility-chews' }
};

function pvShopLinkFor(s) {
  var m = PV_SHOP_MAP[s.purpose];
  if (!m) return '';
  return '<div style="margin-top:10px;"><a href="' + m.url + '" style="display:inline-block;background:#c9a84c;color:#1a1a2e;font-size:12px;font-weight:700;padding:6px 14px;border-radius:14px;text-decoration:none;">Reorder ' + m.name + ' &rarr;</a></div>';
}

function renderSupplements(supplements) {
  var list = document.getElementById('supplementsList');
  if (!supplements || supplements.length === 0) {
    list.innerHTML = '<div style="text-align:center;padding:40px 20px;"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5" style="margin-bottom:12px;"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2z"/><line x1="9" y1="9" x2="15" y2="9"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="12" y2="17"/></svg><h3 style="color:#888;font-weight:600;margin-bottom:6px;">No supplements yet</h3><p style="color:#aaa;font-size:14px;">Track your pet\'s supplements, vitamins, and products here</p></div>';
    return;
  }

  var purposeLabels = { joints: 'Joint support', skin: 'Skin & coat', anxiety: 'Calming', dental: 'Dental', ears: 'Ears', eyes: 'Eyes', digestion: 'Digestion', immunity: 'Immunity', senior: 'Senior care', other: 'Other' };

  list.innerHTML = supplements.map(function(s) {
    var days = Math.floor((new Date() - new Date(s.startDate)) / (1000 * 60 * 60 * 24));
    var purposeText = purposeLabels[s.purpose] || s.purpose || '';
    var statusClass = s.active ? 'ok' : 'attention';
    var statusText = s.active ? 'Active' : 'Paused';

    return '<div style="background:#f9f7f3;border-radius:12px;padding:18px;margin-bottom:12px;border-left:3px solid #c9a84c;">' +
      '<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:8px;">' +
        '<div><strong style="font-size:16px;color:#1a1a2e;">' + s.name + '</strong>' +
        (purposeText ? '<span style="display:inline-block;margin-left:8px;padding:2px 8px;background:#c9a84c22;color:#c9a84c;border-radius:10px;font-size:11px;font-weight:600;">' + purposeText + '</span>' : '') +
        '</div>' +
        '<div style="display:flex;gap:6px;">' +
          '<button onclick="toggleSupplement(\'' + s.id + '\')" style="background:none;border:1px solid ' + (s.active ? '#28a745' : '#ffc107') + ';color:' + (s.active ? '#28a745' : '#ffc107') + ';padding:3px 10px;border-radius:12px;font-size:11px;cursor:pointer;">' + statusText + '</button>' +
          '<button onclick="deleteSupplement(\'' + s.id + '\')" style="background:none;border:1px solid #dc3545;color:#dc3545;padding:3px 8px;border-radius:12px;font-size:11px;cursor:pointer;">X</button>' +
        '</div>' +
      '</div>' +
      (s.dosage ? '<div style="color:#555;font-size:13px;margin-bottom:4px;">Dosage: ' + s.dosage + '</div>' : '') +
      '<div style="color:#888;font-size:12px;">Started ' + new Date(s.startDate).toLocaleDateString('en-US', {month:'long', day:'numeric', year:'numeric'}) + ' (' + days + ' days ago)</div>' +
      (s.notes ? '<div style="color:#666;font-size:13px;margin-top:6px;font-style:italic;">' + s.notes + '</div>' : '') +
      pvShopLinkFor(s) +
    '</div>';
  }).join('');
}

function toggleSupplement(id) {
  var supplements = JSON.parse(localStorage.getItem('petvault_supplements')) || [];
  var s = supplements.find(function(x) { return x.id === id; });
  if (s) {
    s.active = !s.active;
    localStorage.setItem('petvault_supplements', JSON.stringify(supplements));
    loadPetDetails(currentPetId);
  }
}

function deleteSupplement(id) {
  if (!confirm('Remove this supplement?')) return;
  var supplements = JSON.parse(localStorage.getItem('petvault_supplements')) || [];
  supplements = supplements.filter(function(x) { return x.id !== id; });
  localStorage.setItem('petvault_supplements', JSON.stringify(supplements));
  loadPetDetails(currentPetId);
}

/* ===== USER PROFILE (local) ===== */

function openLoginModal() {
  var saved = JSON.parse(localStorage.getItem('petvault_user')) || {};
  if (saved.email) {
    document.getElementById('loginEmail').value = saved.email;
    document.getElementById('loginName').value = saved.name || '';
  }
  document.getElementById('loginModal').classList.add('active');
}

function closeLoginModal() {
  document.getElementById('loginModal').classList.remove('active');
}

function handleLogin(event) {
  event.preventDefault();
  var email = document.getElementById('loginEmail').value.trim();
  var name = document.getElementById('loginName').value.trim();

  if (!email) return;

  var userData = { email: email, name: name, loginDate: new Date().toISOString() };
  localStorage.setItem('petvault_user', JSON.stringify(userData));

  closeLoginModal();
  updateUserUI();
  syncToServer();
}

function updateUserUI() {
  var user = JSON.parse(localStorage.getItem('petvault_user'));
  var loginBtn = document.getElementById('loginBtn');
  var emailSpan = document.getElementById('userEmail');
  var syncSpan = document.getElementById('syncStatus');

  if (user && user.email) {
    loginBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align:-2px;margin-right:4px;"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>' + (user.name || user.email.split('@')[0]);
    loginBtn.style.borderColor = '#28a745';
    loginBtn.style.color = '#28a745';
    emailSpan.textContent = user.email;
    emailSpan.style.display = 'inline';
    syncSpan.style.display = 'inline';
    syncSpan.textContent = 'Saved on this device';
  }
}

function syncToServer() {
  var syncSpan = document.getElementById('syncStatus');
  if (syncSpan) { syncSpan.style.display = 'inline'; syncSpan.textContent = 'Saved on this device'; syncSpan.style.color = '#28a745'; }
}

function loadFromServer() {
  /* No backend configured - all data lives privately in this browser. */
}
